import { Callable } from '@vimeo/core/types/generic';

import { detectBrowser } from '../browser/browser_detection';

/**
 * Scroll to an end of provided container element based on dom element props.
 */
export function scrollToVerticalEnd(
  container: HTMLElement,
  behavior: ScrollBehavior = 'smooth',
): void {
  container.scrollTo({ left: 0, top: container.scrollHeight, behavior });
}

/**
 * Transform vertical scrolling to horizontal scrolling.
 * scroll up -> scroll left
 * scroll down -> scroll right
 */
export function transformHorizontalScrollsToVertical(element: HTMLElement): Callable {
  const onMouseWheel = (event: WheelEvent) => {
    const { deltaY } = event;

    if (deltaY !== 0 && deltaY !== -0) {
      element.scrollLeft = element.scrollLeft + deltaY;

      event.stopPropagation();
      event.preventDefault();
    }
  };

  element.addEventListener('mousewheel', onMouseWheel as Callable);
  return () => element.removeEventListener('mousewheel', onMouseWheel as Callable);
}

/**
 * Scroll element into current view with options.
 *
 * Note: for control of parent elements where to scroll use options, prevent whole page from scrolling when needed.
 * Note: if not used carefully with proper config may scroll parent window from iframe.
 *
 * @param element - element to scroll into width
 * @param options - configuration of scroll behaviour
 */
export function scrollElementIntoView(
  element: HTMLElement,
  options: ScrollIntoViewOptions = {},
): void {
  const browser = detectBrowser();
  const isFirefox = browser?.name === 'firefox';
  const scrollOptions: ScrollIntoViewOptions = {
    ...options,
    ...(isFirefox && { behavior: 'auto' }),
  };

  element.scrollIntoView(scrollOptions);
}

/**
 * Get element current vertical scroll.
 */
export function getElementVerticalScroll(element: HTMLElement): number {
  return element.scrollHeight - (element.scrollTop + element.clientHeight);
}
